import React, { ReactNode } from 'react'
import { Box } from '@mantine/core'
import AppText from './AppText'

export type ProfileEmptyPanelProps = {
  title: string;
  message: string;
  action?: ReactNode;
}

export default function ProfileEmptyPanel ({ title, message, action }: ProfileEmptyPanelProps) {
  return (
    <Box sx={{ padding: '32px 0', textAlign: 'center' }}>
      <AppText
        sx={{
          fontFamily: 'Oswald, sans-serif',
          fontSize: 15,
          color: 'var(--gs-muted)',
          letterSpacing: 0.5,
          marginBottom: 'var(--gs-xs)'
        }}
      >
        {title}
      </AppText>
      <AppText
        size="xs"
        sx={{
          fontFamily: 'DM Sans, sans-serif',
          color: 'var(--gs-muted)',
          marginBottom: action ? 'var(--gs-md)' : 0
        }}
      >
        {message}
      </AppText>
      {action}
    </Box>
  )
}
